import { forwardRef, HTMLAttributes } from 'react'

type SVGIconProps = HTMLAttributes<SVGSVGElement> & { symbol?: string }

const SVGIcon = forwardRef<SVGSVGElement, SVGIconProps>(({ symbol, ...props }, ref) => {
  return (
    <svg ref={ref} {...props}>
      <use xlinkHref={`#${symbol}`} />
    </svg>
  )
})

export default SVGIcon
